import { BizTerminateAccountForm } from '../components/BizTerminateAccountForm'
import { BizPaymentInformation } from '../components/BizPaymentInformation'
import { BizCompanyInformationForm } from '../components/BizCompanyInformationForm'
import { BizSubscriptionForm } from '../components/BizSubscriptionForm'
import { bizApi, useBizUsers } from '../BizApi'
import { Redirect } from '@jotta/ui/Redirect'

export function BizSettingsRoute() {
  const { data: subscription } =
    bizApi.subscription.getPaymentInfo.useSuspenseQuery()
  const { maxUserCount, users } = useBizUsers()
  const userCount = users.length
  const changeSubscriptionOption = subscription.changeSubscriptionOption

  return changeSubscriptionOption.case === 'manageSubscriptionExternally' ? (
    <Redirect to={changeSubscriptionOption.value.url} />
  ) : (
    <>
      <div className="grid max-w-4xl grid-cols-1 grid-rows-3 gap-3 md:grid-cols-max-fr1">
        <div className="row-span-3 grid">
          <BizCompanyInformationForm />
        </div>
        <BizSubscriptionForm
          subscription={subscription}
          userCount={userCount}
          maxUserCount={maxUserCount}
        />
        <BizPaymentInformation subscription={subscription} />
        <BizTerminateAccountForm />
      </div>
    </>
  )
}
